import * as React from "react"

const SvgComponent = ({fill}) => (
  <svg
    width={20}
    height={20}
    fill="none"
    
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 5.53a1 1 0 0 1 1 1v2.824a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V6.53a1 1 0 0 1 1-1h4.25Zm0 6.431a1 1 0 0 1 1 1v2.823a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1v-2.823a1 1 0 0 1 1-1h4.25Zm4.5 4.823a1 1 0 0 1-1-1v-2.823a1 1 0 0 1 1-1h4.25a1 1 0 0 1 1 1v2.823a1 1 0 0 1-1 1h-4.25Zm0-6.43a1 1 0 0 1-1-1V6.53a1 1 0 0 1 1-1h4.25a1 1 0 0 1 1 1v2.823a1 1 0 0 1-1 1h-4.25ZM19 20a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18Z"
      fill={fill}
    />
  </svg>
)

export default SvgComponent
